module.exports = __webpack_public_path__ + "static/media/icn_close_light.6a11117d.svg";